import Cookies from "js-cookie";
const axios = require("axios");

const helpers = {
  axiosGetCall: async (url, data) => {
    let res = await axios.get(
      `${process.env.REACT_APP_BASE_URL + "/jwt_api" + url}`,
      {
        headers: {
          "Content-Type": "application/json",
          Authorization: "Bearer " + Cookies.get("jwt"),
        },
        params: { ...data, user_id: Cookies.get("uId") },
      }
    );
    let response = await res.data;
    return { response, res };
  },

  axiosPostCall: async (url, data) => {
    let res = await axios.post(
      `${process.env.REACT_APP_BASE_URL + "/jwt_api" + url}`,
      {
        ...data,
        user_id: Cookies.get("uId"),
      }
    );
    let response = await res.data;
    return { response, res };
  },

  axiosDeleteCall: async (url, data) => {
    let res = await axios({
      method: "delete",
      url: url,
      headers: {
        "Content-Type": "application/json",
        Authorization: "Bearer " + Cookies.get("jwt"),
      },
      params: { ...data },
    });
    let response = await res.data;
    return { response, res };
  },
};

export default helpers;
